import { Download } from "@mui/icons-material"
import { Alert, Button, Stack } from "@mui/material"
import PDF from "../Tools/PDF"

export default function Success({data}){

    return <Stack spacing={1}>

        <Alert severity='success'>Le document a été signé électroniquement.</Alert>

        <Button
            startIcon={<Download />}
            sx={{alignSelf: 'start'}}
            href={data.url}
            target="_blank"
            rel="noopener noreferrer"
            download
        >
            Télécharger le document
        </Button>

        <PDF url={data.url}/>

    </Stack>
} 